<nb-card>
  <nb-card-header class="d-flex justify-content-between align-items-center">
    <div>
      <h3>Email Components</h3>
      <small>Manage reusable email components for your templates</small>
    </div>
    <div>
      <button nbButton status="primary" size="small" (click)="onCreateComponent()">Create Component</button>
    </div>
  </nb-card-header>

  <nb-card-body>
    <!-- Theme Selector Row -->
    <div class="d-flex align-items-center" style="gap: 8px; margin-bottom: 12px">
      <nb-form-field>
        <nb-icon nbPrefix icon="color-palette-outline"></nb-icon>
        <nb-select placeholder="Preview Theme" [formControl]="selectedThemeControl" size="small">
          <nb-option value="">Default Theme</nb-option>
          <nb-option *ngFor="let theme of availableThemes" [value]="theme.id">{{ theme.name }}</nb-option>
        </nb-select>
      </nb-form-field>
    </div>

    <!-- Filters Row -->
    <div class="filters-row d-flex align-items-center" style="gap: 8px; margin-bottom: 12px">
      <nb-form-field>
        <nb-icon nbPrefix icon="grid-outline"></nb-icon>
        <nb-select placeholder="Category" [formControl]="categoryFilterControl" size="small">
          <nb-option value="">All Categories</nb-option>
          <nb-option *ngFor="let category of categories" [value]="category">{{ getCategoryLabel(category) }}</nb-option>
        </nb-select>
      </nb-form-field>
      <nb-form-field>
        <nb-icon nbPrefix icon="toggle-left-outline"></nb-icon>
        <nb-select placeholder="Active" [formControl]="activeFilterControl" size="small">
          <nb-option [value]="true">Active</nb-option>
          <nb-option [value]="false">Inactive</nb-option>
        </nb-select>
      </nb-form-field>
      <nb-form-field>
        <nb-icon nbPrefix icon="layers-outline"></nb-icon>
        <nb-select placeholder="Type" [formControl]="systemComponentControl" size="small">
          <nb-option value="">All</nb-option>
          <nb-option value="true">System</nb-option>
          <nb-option value="false">Custom</nb-option>
        </nb-select>
      </nb-form-field>
    </div>

    <div class="components-grid" *ngIf="!loading">
      <div
        class="component-card"
        *ngFor="let component of components"
        [class.inactive]="!component.is_active"
        (click)="onCardClick(component)"
        [attr.data-component-id]="component.id"
      >
        <!-- Delete Button (Subtle, appears on hover) -->
        <button class="delete-btn" *ngIf="!component.is_system_component" (click)="onDeleteClick(component, $event)" title="Delete Component">
          <svg viewBox="0 0 24 24" class="icon">
            <path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" />
          </svg>
        </button>

        <!-- MJML Preview -->
        <div class="mjml-preview" [innerHTML]="getRenderedMjml(component)"></div>

        <!-- Component Info -->
        <div class="component-info">
          <div class="component-info-content">
            <div class="component-meta">
              <h3 class="component-name">{{ component.name }}</h3>
              @if (component.description) {
              <p class="component-description">{{ component.description }}</p>
              } @else {
              <p class="component-description">No description provided</p>
              }
            </div>

            <div class="component-badges">
              <span class="category-badge">{{ getCategoryLabel(component.category) }}</span>
              @if (component.is_system_component) {
              <span class="system-badge">System</span>
              }
              <span class="status-badge" [class.active]="component.is_active" [class.inactive]="!component.is_active">
                {{ component.is_active ? 'Active' : 'Inactive' }}
              </span>
            </div>

            <div class="component-stats" *ngIf="component.variables && component.variables.length > 0">
              <span class="variables-count">{{ component.variables.length }} variable(s)</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Delete Confirmation Dialog -->
    <div class="delete-confirmation" *ngIf="showDeleteConfirmation" (click)="cancelDelete()">
      <div class="confirmation-dialog" (click)="$event.stopPropagation()">
        <div class="dialog-header">
          <h3>Delete Component</h3>
        </div>
        <div class="dialog-content">
          <p>
            Are you sure you want to delete "<strong>{{ componentToDelete?.name }}</strong
            >"?
          </p>
          <p class="warning-text">This action cannot be undone.</p>
        </div>
        <div class="dialog-actions">
          <button class="btn-cancel" (click)="cancelDelete()">Cancel</button>
          <button class="btn-delete" (click)="confirmDelete()">Delete</button>
        </div>
      </div>
    </div>

    <div class="loading-state" *ngIf="loading">
      <div class="loading-spinner"></div>
      <p>Loading components...</p>
    </div>

    <div class="empty-state" *ngIf="!loading && components.length === 0">
      <svg viewBox="0 0 24 24" class="empty-icon">
        <path d="M4,6H20V16H4M20,18A2,2 0 0,0 22,16V6C22,4.89 21.1,4 20,4H4C2.89,4 2,4.89 2,6V16A2,2 0 0,0 4,18H20M6,8V14H8V10H10V8H6M12,8H14V14H12V8M16,8V14H18V8H16Z" />
      </svg>
      <h3>No Components Found</h3>
      <p>Create your first email component or adjust your search filters.</p>
      <button class="create-btn" (click)="onCreateComponent()">
        <svg viewBox="0 0 24 24" class="icon">
          <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
        </svg>
        Create Component
      </button>
    </div>
  </nb-card-body>
</nb-card>
